export interface BusinessProperty {
    key: string;
    value: string;
    isRestrictValue?: boolean;
    values?: string[];
}

export interface Provider {
    name: string;
    active: boolean;
    weight: number;
    blockDesactivation: boolean;
}

export function normalizePropertyData(data: any): {
    isRestrictValue: boolean;
    values: any[];
    value: string | number;
    key: string
}[] {
    if (Array.isArray(data)) {
        // Formato de array
        return data.map(item => ({
            key: item.key,
            value: item.value,
            isRestrictValue: item.isRestrictValue || false,
            values: item.values || [],
        }));
    } else if (typeof data === 'object' && data !== null) {
        // Formato de objeto
        return Object.entries(data).map(([key, value]) => ({
            key,
            value: value as string | number,
            isRestrictValue: false,
            values: [],
        }));
    } else {
        // Formato inválido
        console.error('Invalid data format:', data);
        return [];
    }
}

export function normalizeProviderData(data: any): {
    name: string;
    active: boolean;
    weight: number;
    blockDesactivation: boolean;
}[] {
    if (Array.isArray(data)) {
        // Formato de array
        return data.map(item => ({
            name: item.name,
            active: item.active,
            weight: item.weight,
            blockDesactivation: item.blockDesactivation,
        }));
    } else {
        // Formato inválido
        console.error('Invalid data format:', data);
        return [];
    }
}